import React, {useEffect, useState} from 'react';
import {Button, FormControl} from "react-bootstrap";
import {useStores} from "../../stores/Context";
import {v4 as uuidv4} from "uuid";
import styles from "./CreateForm.module.scss";
import FormConfiguration, {BoutonSupprimerWidget, TitreConfigurerPhidget, WidgetTitre} from "./FormConfiguration";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";

const CreateURL = () => {
    const {widgetStore, uiStore, createWidgetStore} = useStores();
    const [typeForm, setTypeForm] = useState('');
    const [widgetName, setWidgetName] = useState('');
    const [widgetAdresseURL, setWidgetAdresseURL] = useState('');
    const [nameError, setNameError] = useState(false);
    const [urlError, setUrlError] = useState(false);
    const [iframeError, setIframeError] = useState(false); // Pour indiquer une erreur avec l'iframe

    useEffect(() => {
        if (createWidgetStore.idWidgetModification === '') {
            setTypeForm("creation");
        } else {
            setTypeForm("modification");
            widgetStore.getWidgetDataConfigById(createWidgetStore.idWidgetModification)
                .then(value => {
                    setWidgetName(value.nomWidget)
                    setWidgetAdresseURL(value.config.url_url_adress)
                })
                .catch(error => {
                    uiStore.closePanel();
                    console.log("error", error)
                });
        }
    }, [createWidgetStore.idWidgetModification]);

    // Vérifie et corrige automatiquement l'URL
    const handleURLChange = (e) => {
        const url = e.target.value.trim();
        setIframeError(false); // Réinitialise l'erreur iframe

        // Vérification du préfixe HTTP/HTTPS
        if (!url.startsWith("http://") && !url.startsWith("https://") && url.length > 0) {
            setWidgetAdresseURL(`https://${url}`);
        } else {
            setWidgetAdresseURL(url);
        }
    };

    function getData() {
        if (widgetAdresseURL.length > 0 && widgetName.length > 0) {
            if (typeForm === "creation") {
                widgetStore.addWidgetAvailable({
                    idWidget: uuidv4(),
                    typeWidget: 'WidgetURL',
                    nomWidget: widgetName,
                    config: {
                        url_url_adress: widgetAdresseURL
                    }
                });
            } else if (typeForm === "modification") {
                widgetStore.updateWidgetAvailable({
                    idWidget: createWidgetStore.idWidgetModification,
                    typeWidget: 'WidgetURL',
                    nomWidget: widgetName,
                    config: {
                        url_url_adress: widgetAdresseURL
                    }
                });
            }
            uiStore.backNivOAfterAddPhidget();
        } else {
            if (widgetAdresseURL.length === 0) {
                setUrlError(true);
            } else {
                setUrlError(false);
            }
            if (widgetName.length === 0) {
                setNameError(true);
            } else {
                setNameError(false);
            }
        }
    }

    return (
        <>
            <div>
                <TitreConfigurerPhidget/>
                <WidgetTitre titre={"Page web"}/>
            </div>

            <div className={styles.listeChampsFormulaire}>
                <div className={styles.form_add_widget}>
                    <label>Nom du phidget :</label>
                    <FormControl
                        className={`${nameError && 'border border-danger'}`}
                        onChange={(e) => setWidgetName(e.target.value)}
                        value={widgetName}
                    />
                    {nameError && <small className="text-danger">Nom obligatoire</small>}
                </div>

                <div className={styles.form_add_widget}>
                    <label>URL entière :</label>
                    <FormControl
                        className={`${urlError && 'border border-danger'}`}
                        onChange={handleURLChange}
                        value={widgetAdresseURL}
                        placeholder={"https://www.example.com/"}
                    />
                    {urlError && <small className="text-danger">Adresse obligatoire</small>}
                    <small className="text-muted">
                        Saisir l'URL entière, exemple : https://www.toshibatec-teis.com/
                    </small>
                </div>

                <div className={styles.WidgetButtonContent}>
                    {(createWidgetStore.idWidgetModification === '') ? <FormConfiguration/> :
                        <BoutonSupprimerWidget
                            idWidget={createWidgetStore.idWidgetModification}
                            widgetName={widgetName}
                            typeWidget={"WidgetURL"}
                        />}
                    <BtnPrimary onClick={getData}>{(createWidgetStore.idWidgetModification === '') ? "Ajouter à mes phidgets" : "Modifier mon phidget"}</BtnPrimary>
                </div>

                {/* Section pour afficher l'iframe */}
                <div className={styles.iframePreview}>
                    <label>Prévisualisation :</label>
                    {widgetAdresseURL && (
                        <iframe
                            src={widgetAdresseURL}
                            width="100%"
                            onError={() => setIframeError(true)} // Détecte si l'URL ne peut pas être chargée
                        />
                    )}
                    {iframeError &&
                        <small className="text-danger">Cette URL ne peut pas être affichée dans une iframe.</small>}
                </div>
            </div>
        </>
    );
};

export default CreateURL;